module.exports = require("./ta-LK.d.ts");